export default "assets/images/icons/contact-pin-3e0f070d.svg";